import utils from "../../../src/js/utils";

var sugarChart = {
	//TODO vedere se si riesce ad unire i 2 forEach e ridurre variabili
	el: document.querySelector(".sugar-chart-block"),
	svg: {
		set: function () {
			var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
			var poly = document.createElementNS(
				"http://www.w3.org/2000/svg",
				"polyline"
			);
			var width = sugarChart.el.querySelector(".wines-list").offsetWidth;
			var height = sugarChart.el.offsetHeight;
			svg.setAttribute("viewbox", "0 0 " + width + " " + height);
			svg.setAttribute("id", "sugar-path");
			var newPoints = "";
			var pointsElems = sugarChart.el.querySelectorAll(".wines-list .wine");
			var parentBound = sugarChart.el.getBoundingClientRect();
			utils.forEach(pointsElems, function (index, el) {
				var parent = el.parentElement,
					sugarContent = Math.round(parent.getAttribute("data-sugar"));
				parent.style.gridColumnStart = sugarContent;
				parent.style.gridColumnEnd = sugarContent + 1;
				var bound = el.getBoundingClientRect();
				var left = Number(bound.left + bound.width + 5);
				var top = Number(bound.top - parentBound.top);
				newPoints += left + " " + top + " ";
			});
			poly.setAttribute("points", newPoints);
			svg.appendChild(poly);
			sugarChart.el.appendChild(svg);
			var pathLength = poly.getTotalLength();
			poly.style.strokeDashoffset = pathLength;
			poly.style.strokeDasharray = pathLength;
		},
		init: function () {
			sugarChart.svg.set();
		},
	},
	animation: function () {
		var poly = sugarChart.el.querySelector("polyline");
		var pointsElems = sugarChart.el.querySelectorAll(".wines-list .wine");
		var progressBar = sugarChart.el.querySelector(".progress");
		var progressBarText = progressBar.querySelector("span");

		gsap
			.timeline({
				scrollTrigger: {
					trigger: sugarChart.el,
					start: "top top+=" + utils.screen.height / 2,
					end: "bottom bottom+=" + utils.screen.height / 4,
					scrub: 1.6,
					onUpdate: function (self) {
						var index = parseInt((pointsElems.length - 1) * self.progress);
						var bottleInView = pointsElems[index];
						if (!bottleInView.classList.contains("in-view")) {
							bottleInView.classList.add("in-view");
						}
					},
				},
			})
			.to(poly, { strokeDashoffset: "0", duration: 1, ease: "none" });

		if (utils.screen.width >= 768) {
			progressBar.style.opacity = "1";
			progressBar.style.transform =
				"translateX(" +
				(pointsElems[0].getBoundingClientRect().left +
					pointsElems[0].getBoundingClientRect().width +
					5 -
					progressBar.offsetWidth / 2) +
				"px)";

			var progressLine = gsap.timeline({
				scrollTrigger: {
					trigger: sugarChart.el,
					start: "top top+=" + utils.screen.height / 2,
					end: "bottom bottom+=" + utils.screen.height / 4,
					scrub: 1.6,
					onUpdate: function (self) {
						var index = parseInt((pointsElems.length - 1) * self.progress);
						if (index === pointsElems.length - 1) {
							return;
						}
						var min = Number(pointsElems[index].getAttribute("data-grado"));
						var max = Number(pointsElems[index + 1].getAttribute("data-grado"));
						var diff = max - min;

						var stepProgress = self.progress * (pointsElems.length - 1) - index;

						var value = (min + diff * stepProgress).toFixed(2);

						progressBarText.textContent = value;
					},
					onLeave: function () {
						var value =
							pointsElems[pointsElems.length - 1].getAttribute("data-grado") +
							".00";
						progressBarText.textContent = value;
					},
				},
			});

			utils.forEach(pointsElems, function (index, point) {
				if (index === 0) {
					return;
				}
				var segmentLeft = Number(
					point.getBoundingClientRect().left +
						point.getBoundingClientRect().width +
						5 -
						progressBar.offsetWidth / 2
				);

				progressLine.add(
					gsap.to(progressBar, {
						x: segmentLeft,
						duration: 1,
						ease: "none",
					})
				);
			});
		}
	},
	init: function () {
		if (sugarChart.el) {
			sugarChart.svg.init();
			sugarChart.animation();
		}
	},
};

utils.domReady(function () {
	sugarChart.init();
});
